
import React, { useState, useEffect, useMemo } from 'react';

import PhoneInput,{ getCountries, isValidPhoneNumber } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json';
import 'react-phone-number-input/style.css';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import InfoPopover from '../Common/InfoPopover';
import { useNavigate } from 'react-router-dom';
import {Popover} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import OtpInputModal from '../Company/OtpInputModal';
import SRQService from '../../Services/SRQService';
import ProjectsService from '../../Services/ProjectsService';
import ServiceRequestModel from './ServiceRequestModel';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import './CreateCompany.css';

const CreateCompany = ({ onCancel }) => {
  const navigate = useNavigate();
  const pageReload = () => {
    // 👇️ navigate to /
    window.location.reload();
  };
  const parseLines = (value) => value.replace(/(\\n)/g, "\n");
  
  const [isCreateSRQButtonActive, setIsCreateSRQButtonActive] = useState(false)
  // const [flagSelected, setFlagSelected] = useState(false);
  
  //company
  const [newCompanyName, setNewCompanyName] = useState('')
  const [newCompanyCountryCode, setNewCompanyCountryCode] = useState('')
  const [newCompanyRegistrationCode, setNewCompanyRegistrationCode] = useState('')
  const [newCompanyDescription, setNewCompanyDescription] = useState('')
  //representative
  const [representativeName, setRepresentativeName] = useState('')
  const [representativeSurname, setRepresentativeSurname] = useState('')
  const [representativeEmailId, setRepresentativeEmailId] = useState('')
  const [representativePhoneNumber, setRepresentativePhoneNumber] = useState('')
  // const [representativeCountryCode, setRepresentativeCountryCode] = useState('')
  // const [representativeCountry, setRepresentativeCountry] = useState({})
  const [validRepPhoneNumber, setValidRepPhoneNumber] = useState(true);
  //AdditionalDetails
  const [additionalDetails, setAdditionalDetails] = useState('')
  //otpinput
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const[OtpDataFromModal,setOtpDataFromModal] = useState([]);
  //Confirmation modal
  const [modalShow, setModalShow] = React.useState(false);
  var otpInputModelOpenendForAction = '';

  // console.log("countrycode:"+representativeCountryCode);
  console.log("phonenumber:"+representativePhoneNumber);
  console.log("country:"+newCompanyCountryCode);
  // console.log(representativeCountry.dialCode);

  const countries = useMemo(
      () =>
        getCountries().sort((a, b) =>
          en[a].localeCompare(en[b])
        ),
      []
    );

  const handleSelectCountryCode = (event) => {
    let eValue=event.target.value;
    setNewCompanyCountryCode(eValue);
  }

 
  //confirmation modal view
  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static' 
        keyboard="False"
        dialogClassName='my-modal'
       


      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
          Confirmation on  service request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
          Request accepted for CreateCompany, request number shall be updated soon!</p>
        </Modal.Body>
        <Modal.Footer>
        <button className="ui button comm-button-style primary" onClick={onServiceRequestCreated}>OK</button>
        </Modal.Footer>
      </Modal>
    );
  }
  function clearAllFields()
  {
    setNewCompanyName('');
  setNewCompanyCountryCode('')
  setNewCompanyRegistrationCode('')
   setNewCompanyDescription('')
 setRepresentativeName('')
 setRepresentativeSurname('')
 setRepresentativeEmailId('')
   setRepresentativePhoneNumber('')
  // setRepresentativeCountryCode('')
  //  setRepresentativeCountry({})
   setAdditionalDetails('')
  }
  const onServiceRequestCreated =  ()  =>{
    console.log("inside onServiceRequestCreated function")
    clearAllFields();
    setModalShow(false);
    window.location.href="/viewserviceRequests";
    
    
   
  };

  function createCompanyDefaultRequestBuilder(){
    
   
  };
  
  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }
  async function verifyOtp(OtpDataFromModal){
  
    if(OtpDataFromModal.length!==0){
    
      console.log(OtpDataFromModal)
      OtpDataFromModal  = Number(OtpDataFromModal.join(''));
      //alert("otp:"+OtpDataFromModal)
      // ServiceRequestModel.companyId=null;
      // ServiceRequestModel.projectId=null;
      ServiceRequestModel.requestType="CreateCompany";
      ServiceRequestModel.requestText=additionalDetails.replace(/(?:\r\n|\r|\n)/g, ' ');
      ServiceRequestModel.subjectNewUser.displayName = `${representativeName} ${representativeSurname}`;
      ServiceRequestModel.subjectNewUser.email=representativeEmailId;
      ServiceRequestModel.subjectNewUser.mobile=representativePhoneNumber;
      ServiceRequestModel.subjectCompany.name=newCompanyName;
      ServiceRequestModel.subjectCompany.countryCode=newCompanyCountryCode;
      ServiceRequestModel.subjectCompany.registrationCode=newCompanyRegistrationCode;
      ServiceRequestModel.subjectCompany.description=newCompanyDescription.replace(/(?:\r\n|\r|\n)/g, ' ');
      console.log(ServiceRequestModel);
       
     // alert("userDetailsObject.password"+userDetailsObject.password);
     try {
      //alert("verifyOtpforCreateCtedential"+OtpDataFromModal);
      // let temp= createCompanyDefaultRequestBuilder();
      // alert(temp.);
         const response = await SRQService.createNewServiceRequest(ServiceRequestModel,OtpDataFromModal);
         if(response)
         {
          setOtpModalOpen(false);
          setModalShow(true);
         }
              } catch (error) {
                setOtpModalOpen(true);
                // Check if it's an APIM error - let global interceptor handle those
                if (error.response?.data?.code?.startsWith('APIM-')) {
                  console.log('APIM error, letting global interceptor handle it');
                } else {
                  toast.error(error.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 8000, //6 seconds
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                  });
                }
          }
      
      
    
     }
    
      }
  const popover = (data) =>(  
  
    <Popover id="popover-basic" style={{maxWidth: '700px',height:'90px',borderColor:'black',borderStyle:'solid',pointerEvents:'none'}}>    
      <Popover.Body className='row'>  
        <p  className='row'> {data}</p>
      </Popover.Body>  
    </Popover>  
  // popover helper removed post InfoPopover migration
  );

  async function handleCreateSRQButton() {

  }

  const forbiddenCharactersPattern = /[~`%*+"':;\\/]/;
  const representativeNamePattern = /^[\p{L}]+(?:[ '-][\p{L}]+)*$/u;
  const representativeEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const containsDisallowedCharacters = (value = '') =>
    forbiddenCharactersPattern.test(value);

  const isValidDisplayName = (value = '') => {
    const trimmedValue = value.trim();
    return Boolean(trimmedValue && !containsDisallowedCharacters(trimmedValue));
  };

  const isValidRegistrationCode = (value = '') => {
    const trimmedValue = value.trim();
    return Boolean(trimmedValue && !containsDisallowedCharacters(trimmedValue));
  };

  const isValidRepresentativeName = (value) => {
    const trimmedValue = value.trim();
    return representativeNamePattern.test(trimmedValue) && !containsDisallowedCharacters(trimmedValue);
  };

  const isValidRepresentativeEmail = (value) => {
    const email = value.trim();
    return email.length <= 254 && !containsDisallowedCharacters(email) && representativeEmailPattern.test(email);
  };

  const isCreateCompanyFormValid = () =>
    Boolean(
      isValidDisplayName(newCompanyName) &&
      isValidRegistrationCode(newCompanyRegistrationCode) &&
      isValidRepresentativeName(representativeName) &&
      isValidRepresentativeName(representativeSurname) &&
      isValidRepresentativeEmail(representativeEmailId) &&
      representativePhoneNumber &&
      isValidPhoneNumber(representativePhoneNumber)
    );

  //when create button is clicked
  async function handleSubmit() {
    console.log("HI FROM Creeate company")
    //e.preventDefault();
    
    if (!isCreateCompanyFormValid()) {
      toast.error('Please complete all fields with valid values');
      return;
    }

    setIsCreateSRQButtonActive(true);
    //userDetailsObject.password=password;
   
    
    otpInputModelOpenendForAction = "registerCompany";
    setOtpModalOpen(true);
    
    // 
    try {
        const response = await ProjectsService.getStrongConfirmationCode("POST",null,"registerCompany",null,null,null);
    if (response && response.data.channel == "SMS") {
        otpInputModelOpenendForAction = "registerCompany";
        
        
        setOtpModalOpen(true);
       // alert("otp entered from otp modal for deleting credentials is ---->" + OtpDataFromModal);
      }
   
        
    } catch (error) {
        console.log(error);
    }
   // setModalShow(true);  //enable here for modal testing
   
  }

  const resendOtp = async() => {
    await ProjectsService.getStrongConfirmationCode("POST",null,"registerCompany",null,null,null);
  }


  const handleCancel = () => {
    clearAllFields();

    if (onCancel) {
      onCancel();
    }
  }

    return(
    <div id="createCompanyContainer">
    <>
           <li>
    <div className="sec">
      <div className="head-titlw-w head-titl-unset" style={{maxWidth: '50%'}}>
        <h3
          className="sec-title"
          id="CreateCompany-Default-promptForNewCompany"
          data-info=""
        >
          Company Details
        </h3>
        <InfoPopover
          id="infoSelectedServiceRequestType"
          className="info-icon-w pop-common-sel sr-pophover ms-2"
          content={"Please provide the basic information about your company."}
          ariaLabel="Information: company details"
        />
      </div>
      <ul className="serv-req sec-inner-wrap">
        
        <li>
          <div className="mt-3">
            <div className="custom-input-wrapp">
            <FloatingLabel
        controlId="ncInputCompanyName"
        label="Company name"
        className="inputText"
        autoComplete="off"
        onChange={(event) => setNewCompanyName(event.target.value)}
      >
        <Form.Control 
          type="text" 
          placeholder="Enter Company Name"
          maxLength={200}
          pattern="^[a-zA-Z0-9\\s\\-_\\.]{1,200}$"
          value={newCompanyName}
        />
        <span className="input-info-label">Eg: Nexi</span>
        <span className="required-field-op">(Required)</span>
        {newCompanyName && !isValidDisplayName(newCompanyName) && (
          <span style={{ color: '#dc2626', display: 'block', marginTop: '4px' }}>
            Please enter a valid display name
          </span>
        )}
      </FloatingLabel>
             
            </div>
          </div>
        </li>
        <li className="select-drop-message">
          <div className="contact-num-wrap mt-3 row">
            <div className="country-code-w col-5">
            <Form.Select
  value={newCompanyCountryCode}
  style={{ width: '100%' }}
  onChange={handleSelectCountryCode}
>
  <option value="">
    Select Country Code
  </option>

  {countries.map((countryCode) => (
    <option
      key={countryCode}
      value={countryCode}
      className="textdefault"
    >
      {en[countryCode]} ({countryCode})
    </option>
  ))}
</Form.Select>
            </div>
          </div>
        </li>
        <li>
          <div className="edit-input-wrap mt-3">
            <div className="custom-input-wrapp">
            <FloatingLabel
        controlId="ncInputRegistrationCode"
        label="Registration Code"
        className="inputText"
        autoComplete="off"
        onChange={(event) => setNewCompanyRegistrationCode(event.target.value)}
      >
        <Form.Control type="text" placeholder="name@example.com" />
        <span className="input-info-label">Eg: IN025852</span>
        <span className="required-field-op">(Required)</span>
        {newCompanyRegistrationCode && !isValidRegistrationCode(newCompanyRegistrationCode) && (
          <span style={{ color: '#dc2626', display: 'block', marginTop: '4px' }}>
            Please enter a valid registration code
          </span>
        )}
      </FloatingLabel>
            </div>
          </div>
        </li>
        <li>
          <div className="custom-input-wrapp text-area-i mt-3 mb-4">
            <textarea
              id="textAreaModifyDescription"
              className="cust-text-a"
              maxLength={4000}
              tabIndex={1}
              placeholder="Description"
              defaultValue={""}
              onChange={(e) => {setNewCompanyDescription(e.target.value)}}
            />
          </div>
        </li>
        
      </ul>
    </div>
  </li>
     
{/* REPRESENTATIVE DETAILS */}
<li>
    <div className="sec">
      <div className="head-titlw-w head-titl-unset" style={{maxWidth: '39%'}}>
        <h3
          className="sec-title"
          id="CreateCompany-Default-promptForNewCRep"
          data-info=""
        >
          Representative
        </h3>
         <InfoPopover
  id="infoRepresentative"
  className="info-icon-w pop-common-sel sr-pophover ms-2"
  content="Please provide details for the person who will be accountable for managing the company's access to Nexi's production systems (the representative). The representative can use the self-service portal to delegate responsibilities."
  ariaLabel="Information: representative details"
/>
      </div>
      <ul className="serv-req sec-inner-wrap">
        
        <li>
          <div className="mt-3">
            <div className="d-flex gap-3">
              <div className="custom-input-wrapp flex-fill">
                <FloatingLabel
                  controlId="ncInputName"
                  label="Name"
                  className="inputText"
                  autoComplete="off"
                >
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    maxLength={100}
                    value={representativeName}
                    onChange={(event) => setRepresentativeName(event.target.value)}
                  />
                  <span className="input-info-label">Eg: John</span>
                  <span className="required-field-op">(Required)</span>
                </FloatingLabel>
                {representativeName && !isValidRepresentativeName(representativeName) && (
                  <span style={{ color: '#dc2626', display: 'block', marginTop: '4px' }}>
                    Please enter a valid name
                  </span>
                )}
              </div>
              <div className="custom-input-wrapp flex-fill">
                <FloatingLabel
                  controlId="ncInputSurname"
                  label="Surname"
                  className="inputText"
                  autoComplete="off"
                >
                  <Form.Control
                    type="text"
                    placeholder="Surname"
                    maxLength={100}
                    value={representativeSurname}
                    onChange={(event) => setRepresentativeSurname(event.target.value)}
                  />
                  <span className="input-info-label">Eg: Doe</span>
                  <span className="required-field-op">(Required)</span>
                </FloatingLabel>
                {representativeSurname && !isValidRepresentativeName(representativeSurname) && (
                  <span style={{ color: '#dc2626', display: 'block', marginTop: '4px' }}>
                    Please enter a valid surname
                  </span>
                )}
              </div>
            </div>
          </div>
        </li>
        
        <li>
          <div className="mt-3">
            <div className="custom-input-wrapp">
            <FloatingLabel
        controlId="ncInputEmail"
        label="Email Id"
        className="inputText"
        autoComplete="off"
      >
        <Form.Control
          type="email"
          placeholder="Eg: username@domain.com"
          maxLength={254}
          value={representativeEmailId}
          onChange={(event) => setRepresentativeEmailId(event.target.value)}
        />
        <span className="input-info-label">Eg: username@domain.com</span>
        <span className="required-field-op">(Required)</span>
      </FloatingLabel>
      {representativeEmailId && !isValidRepresentativeEmail(representativeEmailId) && (
        <span style={{ color: '#dc2626', display: 'block', marginTop: '4px' }}>
          Please enter a valid email address
        </span>
      )}
             
            </div>
          </div>
        </li>
       
        
        <li>
                    <div className="nc-rep-contact-num-wrap">
                    <div class="country-code-w">
                  
                    
      <div className="phone-input-wrapper">
  <PhoneInput
    international
    value={representativePhoneNumber}
    onChange={(value) => {
      setRepresentativePhoneNumber(value || '');
    }}
    placeholder="Enter phone number"
  />
</div>

      {/* <span className="required-field-op">(Required)</span> */}
                    </div>
                    </div>
                    <span className="form-error error-message-show" style={{visibility: 'hidden'}}>Mobile number is invalid</span>
                  </li>
      
       
      </ul>
    </div>
  </li>

{/* ADDITIONAL DETAILS */}
<li>
    <div className="sec">
      <div className="head-titlw-w head-titl-unset" style={{maxWidth: '50%'}}>
        <h3
          className="sec-title"
          id="CreateCompany-Default-promptForAdditionalDetails"
          data-info=""
        >
          Additional Details
        </h3>
         <InfoPopover
  id="infoAdditionalDetails"
  className="info-icon-w pop-common-sel sr-pophover ms-2"
  content="Please provide any additional information relevant to the registration process here."
  ariaLabel="Information: additional details"
/>
      </div>
      <ul className="serv-req sec-inner-wrap">
        
        <li>
          <div className="custom-input-wrapp text-area-i mt-3 mb-2">
            <div className="dropdown-w-info">
              <div className="width-full">
                <textarea
                  className="cust-text-a"
                  maxLength={4000}
                  placeholder=""
                  id="textAreaModifyAdditionalDetails"
                  tabIndex={1}
                  defaultValue={""}
                  onChange= {(event) => setAdditionalDetails(event.target.value)}
                 
                />
                {/* <span className="required-field-op">(Required)</span> */}
              </div>
              
            </div>
          </div>
        </li>
      </ul>
    </div>
  </li>
  <li className="apim-pop-button-w comm-button-wrap ser-req-btn">
    <button
      className="button comm-button-style primary btn-disable"
      id="btnSubmitRegisterCompany"
      tabIndex={1}
      onClick={handleSubmit}
      disabled={!isCreateCompanyFormValid()}
    >
      Create
    </button>
    <button
      className="button comm-button-style secondary"
      id="btnLoaderRegisterCompany"
      style={{ display: "none" }}
    >
      <i className="icon-plus iconLoader" />
      Creating Service Request..
    </button>
    <button
          type="button"
          className="button comm-button-style secondary"
          onClick={handleCancel}
        >
          Cancel
    </button>
  </li> 
  <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
  {OtpModalOpen &&<OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal}  verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpInputModelOpenendForAction} resendOtp={resendOtp}/>} 
            </>
            </div>
            );
    }
    export default CreateCompany;